import { Stack, StackProps, styled } from '@mui/material';

import ListSeparator from '../../../../../../components/ListSeparator';
import { generateClasses } from '../../../../../../utils/helpers';

export const commentGroupClasses = {
  ...generateClasses('CommentGroup', ['newIndicatorOnFirstCommentInGroup']),
};

export const Root = styled((props: StackProps) => <Stack gap={4} {...props} />)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: 8,
  padding: theme.spacing(3),
}));

export const NewIndicatorWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  /**
   * when new indicator is visible on a comment which is first child of the group,
   * we move new indicator upwards to show it on the border of the comment group.
   */
  transform: 'translateY(-50%)',
}));

export const NewIndicator = styled(ListSeparator)(({ theme }) => ({
  position: 'relative',
  top: 0,
  /** move new indicator edge to the comments panel's edge */
  left: theme.spacing(-2),
  /**
   * extending width to have new indicator width = comments panel width
   * 100% = commentGroupWidth
   * adding 1rem = padding on comments container on left + right
   */
  width: `calc(100% + ${theme.spacing(4)})`,
}));
